<template>
  <layout :title="pageTitle">
    <div class="columns">
      <div class="column is-3">
        <ul class="inner-menu box">
          <li>
            <ScrollLink to="#defaultsDetails">Details</ScrollLink>
          </li>
          <li>
            <ScrollLink to="#reports">Reports</ScrollLink>
          </li>
          <li>
            <ScrollLink to="#welcomes">Welcomes</ScrollLink>
          </li>
          <li>
            <ScrollLink to="#emails">Emails</ScrollLink>
          </li>
          <li>
            <ScrollLink to="#relationships">Relationships</ScrollLink>
          </li>
          <li>
            <ScrollLink to="#questionDescriptions"
              >Question Descriptions</ScrollLink
            >
          </li>
        </ul>
      </div>
      <div class="section column is-9" id="mainbody">
        <ManageDefaults
          :defaults="defaults"
          :relationships="relationships"
          :entity="reseller"
          entityType="App\Models\ResellerDefault"
        />

        <a id="questionDescriptions"></a>
        <QuestionDescriptions v-model="questionDescriptionsForm" />
      </div>
    </div>
  </layout>
</template>

<script>
import Layout from './Layout';
import ScrollLink from '@/Components/Shared/ScrollLink';
import ManageDefaults from '../../Components/Management/ManageDefaults';
import QuestionDescriptions from '../../Components/Management/QuestionDescriptions';

export default {
  components: {
    Layout,
    ScrollLink,
    ManageDefaults,
    QuestionDescriptions,
  },
  props: {
    reseller: { type: Object },
    defaults: { type: Object },
    relationships: { type: Array },
  },
  data() {
    return {
      isSending: true,
      pageTitle: 'System Defaults',
      questionDescriptionsForm: this.defaults.question_descriptions.value,
    };
  },
  methods: {
    updateQuestionDescriptions() {
      let data = {
        questionDescriptions: this.questionDescriptionsForm,
      };
      this.$inertia.patch(route('defaults.updateQuestionDescriptions'), data, {
        preserveScroll: true,
      });
    },
  },
  watch: {
    questionDescriptionsForm: {
      handler(val) {
        let self = this;
        if (self.isSending) {
          this.isSending = false;
          setTimeout(function () {
            self.isSending = true;
            self.updateQuestionDescriptions();
          }, 800);
        }
      },
      deep: true,
    },
  },
};
</script>
